/* eslint-disable react/prop-types */
import {
  AlertTriangle, CheckCircle2, CircleDashed, XCircle
} from 'lucide-react';
import { Badge } from 'src/features/tyre-management/components/ui/badge';
import { cn, titleCase } from '../lib/utils';

const tone = (value) => {
  const normalized = String(value || '').toLowerCase();
  if (['active', 'ready', 'ok', 'normal', 'serviceable', 'complete'].includes(normalized)) return 'good';
  if (['warning', 'due', 'due_soon', 'review_required', 'setup_required', 'not_configured', 'stale'].includes(normalized)) return 'warn';
  if (['critical', 'overdue', 'failed', 'damaged', 'inactive', 'unavailable'].includes(normalized)) return 'bad';
  return 'neutral';
};

const icons = {
  good: CheckCircle2, warn: AlertTriangle, bad: XCircle, neutral: CircleDashed
};

const variants = {
  good: 'success', warn: 'warning', bad: 'destructive', neutral: 'outline'
};

const StatePill = ({ value, label, className }) => {
  const state = tone(value);
  const Icon = icons[state];
  return (
    <Badge variant={variants[state]} className={cn('gap-1.5 whitespace-nowrap', className)}>
      <Icon className="h-3.5 w-3.5" aria-hidden="true" />
      {label || titleCase(value || 'Unknown')}
    </Badge>
  );
};

export default StatePill;
